import React from 'react';
import { ApplicationSubscription } from './ApplicationSubscription';
import SubscriptionContext from './SubscriptionContext';
import useSubscription from './useSubscription';

const SubscriptionWrapper: React.FC<{
    children: (
        data: ApplicationSubscription & {
            organization: string | undefined;
        },
    ) => React.ReactElement;
}> = ({ children }): React.ReactElement => {
    const { organization, subscription } = useSubscription();

    return (
        <SubscriptionContext.Provider
            value={{
                organization,
                isLoaded: true,
            }}
        >
            {children({
                ...subscription,
                organization,
            })}
        </SubscriptionContext.Provider>
    );
};

export default SubscriptionWrapper;
